import { Checkbox, Flex, Form } from "antd";
import { CustomButton } from "@Components/Button";
import FormItem from "@Components/FormItem/FormItem";
import Username from "@Assets/icons/username.svg";
import Lock from "@Assets/icons/lock.svg";
import ArrowRight from "@Assets/icons/arrow-right.svg";
import UnAuthHeader from "../UnAuthHeader";
import useLoginContainer from "./useContainerLogin";

const Login = () => {
  const { handleSubmit, isLoggingIn, form, navigate } = useLoginContainer();

  return (
    <div className="flex justify-center items-center font-mont w-full px-2 sm:px-2 py-4">
      <div className="bg-white w-full max-w-[448px] min-h-[400px] 2xl:min-h-[500px] rounded-[18px] shadow-md p-4 sm:p-6 md:p-8">
        <UnAuthHeader
          headerTitle="Welcome Back"
          subTitle="Please sign in to your admin account"
        />
        <div className="px-2 mb-0 pt-0">
          <Form
            form={form}
            initialValues={{ isRemember: false, email: null, password: null }}
            className="py-0 "
          >
            <FormItem
              name="email"
              label="email"
              rules={[
                { required: true, message: "Please Enter your email" },
                {
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              ]}
              inputConfig={{
                label: "Email",
                type: "email",
                placeholder: "Enter your email",
                leftIcon: <Username />,
                className: "",
              }}
            />
            <FormItem
              name="password"
              label="Password"
              rules={[
                { required: true, message: "Please Enter your password!" },
                { min: 8, message: "Password must be at least 8 characters" },
              ]}
              inputConfig={{
                label: "Password",
                isPassword: true,
                placeholder: "Enter your password",
                leftIcon: <Lock />,
              }}
            />
            <div className="flex flex-col sm:flex-row justify-between gap-3 sm:gap-0 !mb-6">
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Flex align="center" className="flex items-center">
                  <Checkbox className="text-[#001630]" />
                  <p className="text-xs sm:text-sm md:text-[14px] text-[#575757] font-[500]">
                    &nbsp; Remember me
                  </p>
                </Flex>
              </Form.Item>
              <p
                className="text-[#DC2626] font-[500] cursor-pointer !text-xs sm:!text-sm"
                onClick={() => navigate("/forgot-password")}
              >
                Forgot Password?
              </p>
            </div>

            <Form.Item className="text-center max-w-full pt-2 pb-4">
              <CustomButton
                title="Sign In"
                shape="round"
                btnColor="danger"
                type="primary"
                iconPosition="right"
                icon={<ArrowRight />}
                className="w-full h-[44px] sm:h-[50px] font-bold tracking-[1%] !rounded-[12px] text-sm sm:text-base"
                htmlType="submit"
                disabled={isLoggingIn}
                isLoading={isLoggingIn}
                onClick={handleSubmit}
              />
            </Form.Item>

            <div>
              <p className="!text-center !text-xs sm:!text-xs !text-app-secondary !font-inter">
                © 2026 Local Locker. All rights reserved.
              </p>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
